export const metaTrackButtonClick: any = () => {
  window.fbq("trackCustom", "CTA_Button_Clicked", {
    label: "Hero CTA",
    page: window.location.href,
  });
};

export const metaHandleFirstInput = () => {
  window.fbq("trackCustom", "Form_Started", {
    step: "User began form",
    page: window.location.href,
  });
};
export const metaClosePopUp = () => {
  window.fbq("trackCustom", "Popup_Closed", {
    label: "Top Exit Modal",
    page: window.location.href,
  });
};
